var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMetricTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 78,
    viewBox: "0 0 92 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69 31.125C72.3479 31.1225 75.6503 31.9008 78.6448 33.398C81.6392 34.8952 84.2433 37.0702 86.25 39.75",
    stroke: "url(#paint0_linear_5059_716)",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.75 39.75C7.75674 37.0702 10.3608 34.8952 13.3552 33.398C16.3497 31.9008 19.6521 31.1225 23 31.125",
    stroke: "url(#paint1_linear_5059_716)",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 54.125C53.9391 54.125 60.375 47.6891 60.375 39.75C60.375 31.8109 53.9391 25.375 46 25.375C38.0609 25.375 31.625 31.8109 31.625 39.75C31.625 47.6891 38.0609 54.125 46 54.125Z",
    stroke: "url(#paint2_linear_5059_716)",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.875 65.625C27.9389 62.1227 30.881 59.2196 34.4105 57.2028C37.9401 55.1859 41.9348 54.125 46 54.125C50.0652 54.125 54.0599 55.1859 57.5895 57.2028C61.119 59.2196 64.0611 62.1227 66.125 65.625",
    stroke: "url(#paint3_linear_5059_716)",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8594 16.75C58.397 14.6677 59.5078 12.7778 61.0656 11.2951C62.6234 9.81232 64.5658 8.79612 66.6722 8.36187C68.7785 7.92762 70.9644 8.09272 72.9816 8.83842C74.9989 9.58412 76.7666 10.8805 78.084 12.5804C79.4014 14.2803 80.2157 16.3156 80.4345 18.4551C80.6533 20.5946 80.2678 22.7525 79.3217 24.6839C78.3756 26.6153 76.9069 28.2426 75.0824 29.3812C73.2579 30.5198 71.1506 31.1239 69 31.125",
    stroke: "url(#paint4_linear_5059_716)",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0001 31.125C20.8494 31.1239 18.7422 30.5198 16.9177 29.3812C15.0931 28.2426 13.6244 26.6153 12.6783 24.6839C11.7323 22.7525 11.3467 20.5946 11.5655 18.4551C11.7843 16.3156 12.5987 14.2803 13.9161 12.5804C15.2335 10.8805 17.0012 9.58412 19.0184 8.83842C21.0357 8.09272 23.2216 7.92762 25.3279 8.36187C27.4343 8.79612 29.3766 9.81232 30.9344 11.2951C32.4922 12.7778 33.603 14.6677 34.1407 16.75",
    stroke: "url(#paint5_linear_5059_716)",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5059_716",
    x1: 77.625,
    y1: 31.125,
    x2: 77.625,
    y2: 39.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9DAF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBE2F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5059_716",
    x1: 14.375,
    y1: 31.125,
    x2: 14.375,
    y2: 39.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9DAF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBE2F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5059_716",
    x1: 46,
    y1: 25.375,
    x2: 46,
    y2: 54.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABD4FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3DFF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5059_716",
    x1: 46,
    y1: 54.125,
    x2: 46,
    y2: 65.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.216346,
    stopColor: "#C3DEF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3DEF8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5059_716",
    x1: 69.1768,
    y1: 8.125,
    x2: 69.1768,
    y2: 31.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABD4FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCDBF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5059_716",
    x1: 22.8233,
    y1: 8.125,
    x2: 22.8233,
    y2: 31.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABD4FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCDBF9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMetricTeam);
export default __webpack_public_path__ + "static/media/icMetricTeam.51fd55124486e3a60f915fd17563bb7b.svg";
export { ForwardRef as ReactComponent };